define('boxes/events/landingEvent',[], function() {
    'use strict';

    var landingEvent = {};
    landingEvent.ACCOUNT_CREATED = 'ACCOUNT_CREATED';
    return landingEvent;
});
